import * as React from 'react';
import { useEffect } from 'react';
import { Card } from 'reactstrap';
import useSelector from 'hooks/useSelector';
import { userHasPermission } from 'hooks/useRoles';
import { Replay as ReplayIcon } from '@mui/icons-material';
import FatigueAssessmentCardList from "components/portal/fatigueAssessment/FatigueAssessmentCardList";
import { FatigueAssessmentView } from 'components/portal/fatigueAssessment//FatigueAssessmentView';

import './grid-cards.css'


const ActionableFatigueAssessments = () => {
    const profile = useSelector(state => state.profile);

    const hasAdminPermission = () => {
        if (profile === undefined) {
            return false;
        }

        var perm = userHasPermission("web.admin.fatigue-assessment.shift-summary-dashboard", profile?.roles);
        return perm;
    }

    const viewTabs = () => {
        let tabs = [FatigueAssessmentView.MyForm];

        if (hasAdminPermission()) {
            tabs = [...tabs, FatigueAssessmentView.Pending, FatigueAssessmentView.ToAction, FatigueAssessmentView.ToRevisit];
        }

        return tabs;
    }

    const getTitle = () => {
        if (hasAdminPermission()) {
            return "My actionable Fatigue Assessment forms";
        }
        return "My actionable Fatigue Assessment form";
    }


    useEffect(() => {
    }, [profile]);

    return (
        <Card className="secondary-card pt-4 d-block">
            <FatigueAssessmentCardList
                view={viewTabs()}
                title={getTitle()}
                titleIcon={<ReplayIcon />}
                showPageSize={true}
                showHeaderLink={true}
            />
        </Card>
    );
}

export default ActionableFatigueAssessments;
